var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path, _path2, _path3, _path4, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 37.5 37.499999",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "83aebba8d8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.074219 11.707031 L 26.074219 11.707031 L 26.074219 16.957031 L 11.074219 16.957031 Z M 11.074219 11.707031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "961b19a9b9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14 15 L 15 15 L 15 16.957031 L 14 16.957031 Z M 14 15 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "801a3117d7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14 15 L 16 15 L 16 16.957031 L 14 16.957031 Z M 14 15 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8c84f58aa4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14 16 L 15 16 L 15 16.957031 L 14 16.957031 Z M 14 16 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1c1efffbb8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14 16 L 16 16 L 16 16.957031 L 14 16.957031 Z M 14 16 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dd8f1ba106"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21 15 L 23 15 L 23 16.957031 L 21 16.957031 Z M 21 15 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e6fa3ab6da"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22 15 L 24 15 L 24 16.957031 L 22 16.957031 Z M 22 15 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "07a97bfac3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21 16 L 23 16 L 23 16.957031 L 21 16.957031 Z M 21 16 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f5149362e3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22 16 L 24 16 L 24 16.957031 L 22 16.957031 Z M 22 16 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#83aebba8d8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#483434",
    d: "M 19.199219 16.277344 L 17.945312 16.277344 L 16.507812 14.875 L 18.574219 12.675781 L 20.636719 14.875 Z M 26.042969 16.480469 L 22.519531 13.035156 L 21.113281 14.410156 L 18.574219 11.707031 L 16.035156 14.410156 L 14.628906 13.035156 L 11.105469 16.480469 L 11.316406 16.699219 L 11.339844 16.722656 L 11.566406 16.957031 L 14.628906 13.964844 L 17.691406 16.957031 L 17.691406 16.953125 L 19.457031 16.953125 L 19.457031 16.957031 L 19.457031 16.953125 L 22.519531 13.964844 L 25.582031 16.957031 L 25.8125 16.71875 L 25.832031 16.699219 L 26.042969 16.480469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#961b19a9b9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#483434",
    d: "M 14.0625 15.597656 L 14.0625 16.089844 L 14.566406 16.089844 L 14.566406 15.582031 L 14.0625 15.582031 L 14.0625 15.597656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#801a3117d7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#483434",
    d: "M 14.6875 15.597656 L 14.6875 16.089844 L 15.195312 16.089844 L 15.195312 15.582031 L 14.6875 15.582031 L 14.6875 15.597656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8c84f58aa4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#483434",
    d: "M 14.0625 16.226562 L 14.0625 16.71875 L 14.566406 16.71875 L 14.566406 16.210938 L 14.0625 16.210938 L 14.0625 16.226562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1c1efffbb8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#483434",
    d: "M 14.6875 16.226562 L 14.6875 16.71875 L 15.195312 16.71875 L 15.195312 16.210938 L 14.6875 16.210938 L 14.6875 16.226562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dd8f1ba106)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#483434",
    d: "M 21.953125 15.597656 L 21.953125 16.089844 L 22.457031 16.089844 L 22.457031 15.582031 L 21.953125 15.582031 L 21.953125 15.597656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e6fa3ab6da)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#483434",
    d: "M 22.578125 15.597656 L 22.578125 16.089844 L 23.085938 16.089844 L 23.085938 15.582031 L 22.578125 15.582031 L 22.578125 15.597656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#07a97bfac3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#483434",
    d: "M 21.953125 16.226562 L 21.953125 16.71875 L 22.457031 16.71875 L 22.457031 16.210938 L 21.953125 16.210938 L 21.953125 16.226562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f5149362e3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#483434",
    d: "M 22.578125 16.226562 L 22.578125 16.71875 L 23.085938 16.71875 L 23.085938 16.210938 L 22.578125 16.210938 L 22.578125 16.226562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#483434",
    d: "M 18.007812 14.242188 L 18.007812 14.734375 L 18.511719 14.734375 L 18.511719 14.226562 L 18.007812 14.226562 L 18.007812 14.242188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#483434",
    d: "M 19.136719 14.714844 L 19.136719 14.226562 L 18.632812 14.226562 L 18.632812 14.734375 L 19.136719 14.734375 L 19.136719 14.714844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#483434",
    d: "M 18.007812 14.871094 L 18.007812 15.359375 L 18.511719 15.359375 L 18.511719 14.855469 L 18.007812 14.855469 L 18.007812 14.871094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#483434",
    d: "M 19.136719 15.34375 L 19.136719 14.855469 L 18.632812 14.855469 L 18.632812 15.359375 L 19.136719 15.359375 L 19.136719 15.34375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#483434",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.25272, 23.34)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.175781 0 L 0.664062 0 L 0.664062 -0.5 L 1.222656 -0.5 L 1.222656 -0.917969 L 0.664062 -0.917969 L 0.664062 -1.246094 L 1.285156 -1.246094 L 1.285156 -1.679688 L 0.175781 -1.679688 Z M 0.175781 0 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#483434",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.950322, 23.34)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0117188 0 L 0.527344 0 L 0.617188 -0.238281 L 1.191406 -0.238281 L 1.28125 0 L 1.796875 0 L 1.144531 -1.679688 L 0.664062 -1.679688 Z M 0.71875 -0.59375 L 0.90625 -1.113281 L 1.09375 -0.59375 Z M 0.71875 -0.59375 "
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#483434",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.079926, 23.34)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.898438 0.0351562 C 1.355469 0.0351562 1.632812 -0.238281 1.632812 -0.691406 L 1.632812 -1.679688 L 1.152344 -1.679688 L 1.152344 -0.722656 C 1.152344 -0.523438 1.066406 -0.417969 0.898438 -0.417969 C 0.730469 -0.417969 0.648438 -0.523438 0.648438 -0.722656 L 0.648438 -1.679688 L 0.164062 -1.679688 L 0.164062 -0.691406 C 0.164062 -0.238281 0.445312 0.0351562 0.898438 0.0351562 Z M 0.898438 0.0351562 "
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#483434",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.199929, 23.34)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.980469 0.0351562 C 1.558594 0.0351562 1.921875 -0.382812 1.867188 -0.972656 L 0.894531 -0.972656 L 0.894531 -0.632812 L 1.359375 -0.632812 C 1.308594 -0.492188 1.175781 -0.394531 0.984375 -0.394531 C 0.714844 -0.394531 0.558594 -0.585938 0.558594 -0.839844 C 0.558594 -1.105469 0.730469 -1.285156 0.980469 -1.285156 C 1.128906 -1.285156 1.253906 -1.21875 1.320312 -1.113281 L 1.835938 -1.113281 C 1.738281 -1.480469 1.398438 -1.714844 0.972656 -1.714844 C 0.445312 -1.714844 0.0820312 -1.355469 0.0820312 -0.839844 C 0.0820312 -0.320312 0.445312 0.0351562 0.980469 0.0351562 Z M 0.980469 0.0351562 "
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#483434",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.468733, 23.34)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.175781 0 L 1.355469 0 L 1.355469 -0.394531 L 0.65625 -0.394531 L 0.65625 -0.65625 L 1.265625 -0.65625 L 1.265625 -1.042969 L 0.65625 -1.042969 L 0.65625 -1.289062 L 1.328125 -1.289062 L 1.328125 -1.679688 L 0.175781 -1.679688 Z M 0.175781 0 "
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#483434",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.252734, 23.34)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.578125 0 L 1.0625 0 L 1.0625 -1.230469 L 1.570312 -1.230469 L 1.570312 -1.679688 L 0.0664062 -1.679688 L 0.0664062 -1.230469 L 0.578125 -1.230469 Z M 0.578125 0 "
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.064461, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0820312 0 L 0.152344 0 L 0.152344 -0.429688 L 0.335938 -0.148438 L 0.394531 -0.148438 L 0.582031 -0.429688 L 0.582031 0 L 0.652344 0 L 0.652344 -0.558594 L 0.585938 -0.558594 L 0.367188 -0.226562 L 0.148438 -0.558594 L 0.0820312 -0.558594 Z M 0.0820312 0 "
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.007669, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.335938 0.0117188 C 0.507812 0.0117188 0.625 -0.109375 0.625 -0.28125 C 0.625 -0.449219 0.507812 -0.570312 0.335938 -0.570312 C 0.164062 -0.570312 0.046875 -0.449219 0.046875 -0.28125 C 0.046875 -0.109375 0.164062 0.0117188 0.335938 0.0117188 Z M 0.117188 -0.28125 C 0.117188 -0.410156 0.207031 -0.5 0.335938 -0.5 C 0.464844 -0.5 0.554688 -0.410156 0.554688 -0.28125 C 0.554688 -0.148438 0.464844 -0.0585938 0.335938 -0.0585938 C 0.207031 -0.0585938 0.117188 -0.148438 0.117188 -0.28125 Z M 0.117188 -0.28125 "
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.890077, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0820312 0 L 0.273438 0 C 0.445312 0 0.5625 -0.113281 0.5625 -0.28125 C 0.5625 -0.445312 0.445312 -0.558594 0.273438 -0.558594 L 0.0820312 -0.558594 Z M 0.152344 -0.0664062 L 0.152344 -0.492188 L 0.273438 -0.492188 C 0.402344 -0.492188 0.492188 -0.40625 0.492188 -0.28125 C 0.492188 -0.152344 0.402344 -0.0664062 0.273438 -0.0664062 Z M 0.152344 -0.0664062 "
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.709284, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0820312 0 L 0.429688 0 L 0.429688 -0.0664062 L 0.152344 -0.0664062 L 0.152344 -0.253906 L 0.402344 -0.253906 L 0.402344 -0.316406 L 0.152344 -0.316406 L 0.152344 -0.496094 L 0.421875 -0.496094 L 0.421875 -0.558594 L 0.0820312 -0.558594 Z M 0.0820312 0 "
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.402089, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0820312 0 L 0.152344 0 L 0.152344 -0.199219 L 0.273438 -0.199219 L 0.410156 0 L 0.496094 0 L 0.355469 -0.207031 C 0.4375 -0.226562 0.488281 -0.289062 0.488281 -0.378906 C 0.488281 -0.492188 0.410156 -0.558594 0.296875 -0.558594 L 0.0820312 -0.558594 Z M 0.152344 -0.269531 L 0.152344 -0.492188 L 0.289062 -0.492188 C 0.367188 -0.492188 0.414062 -0.453125 0.414062 -0.378906 C 0.414062 -0.308594 0.367188 -0.269531 0.289062 -0.269531 Z M 0.152344 -0.269531 "
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.157295, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0820312 0 L 0.152344 0 L 0.152344 -0.4375 L 0.460938 0 L 0.527344 0 L 0.527344 -0.558594 L 0.457031 -0.558594 L 0.457031 -0.121094 L 0.148438 -0.558594 L 0.0820312 -0.558594 Z M 0.0820312 0 "
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.975702, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.384505, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.234375 0.0117188 C 0.304688 0.0117188 0.359375 -0.0078125 0.402344 -0.0429688 L 0.445312 0 L 0.539062 0 L 0.445312 -0.09375 C 0.476562 -0.140625 0.492188 -0.199219 0.492188 -0.269531 L 0.425781 -0.269531 C 0.425781 -0.222656 0.414062 -0.175781 0.398438 -0.144531 L 0.269531 -0.269531 C 0.367188 -0.308594 0.414062 -0.363281 0.414062 -0.433594 C 0.414062 -0.515625 0.347656 -0.570312 0.25 -0.570312 C 0.152344 -0.570312 0.0859375 -0.515625 0.0859375 -0.4375 C 0.0859375 -0.390625 0.113281 -0.34375 0.15625 -0.296875 C 0.078125 -0.257812 0.0429688 -0.207031 0.0429688 -0.140625 C 0.0429688 -0.046875 0.113281 0.0117188 0.234375 0.0117188 Z M 0.109375 -0.140625 C 0.109375 -0.1875 0.140625 -0.222656 0.203125 -0.246094 L 0.355469 -0.09375 C 0.324219 -0.0664062 0.28125 -0.0546875 0.234375 -0.0546875 C 0.15625 -0.0546875 0.109375 -0.0859375 0.109375 -0.140625 Z M 0.152344 -0.4375 C 0.152344 -0.480469 0.191406 -0.507812 0.25 -0.507812 C 0.308594 -0.507812 0.347656 -0.480469 0.347656 -0.433594 C 0.347656 -0.386719 0.3125 -0.355469 0.222656 -0.320312 C 0.171875 -0.375 0.152344 -0.410156 0.152344 -0.4375 Z M 0.152344 -0.4375 "
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.162111, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.570914, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.328125 0.0117188 C 0.464844 0.0117188 0.574219 -0.0703125 0.609375 -0.195312 L 0.535156 -0.195312 C 0.507812 -0.113281 0.425781 -0.0585938 0.332031 -0.0585938 C 0.207031 -0.0585938 0.117188 -0.152344 0.117188 -0.28125 C 0.117188 -0.410156 0.207031 -0.5 0.332031 -0.5 C 0.425781 -0.5 0.5 -0.449219 0.53125 -0.371094 L 0.605469 -0.371094 C 0.566406 -0.492188 0.460938 -0.570312 0.328125 -0.570312 C 0.164062 -0.570312 0.046875 -0.449219 0.046875 -0.28125 C 0.046875 -0.109375 0.164062 0.0117188 0.328125 0.0117188 Z M 0.328125 0.0117188 "
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.434121, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0820312 0 L 0.425781 0 L 0.425781 -0.0664062 L 0.152344 -0.0664062 L 0.152344 -0.558594 L 0.0820312 -0.558594 Z M 0.0820312 0 "
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.093326, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0117188 0 L 0.0898438 0 L 0.140625 -0.128906 L 0.414062 -0.128906 L 0.464844 0 L 0.539062 0 L 0.308594 -0.558594 L 0.242188 -0.558594 Z M 0.167969 -0.191406 L 0.277344 -0.460938 L 0.386719 -0.191406 Z M 0.167969 -0.191406 "
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.857333, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.269531 0.0117188 C 0.390625 0.0117188 0.46875 -0.0507812 0.46875 -0.148438 C 0.46875 -0.230469 0.414062 -0.277344 0.269531 -0.3125 C 0.164062 -0.339844 0.125 -0.371094 0.125 -0.414062 C 0.125 -0.46875 0.175781 -0.503906 0.253906 -0.503906 C 0.335938 -0.503906 0.386719 -0.460938 0.390625 -0.394531 L 0.460938 -0.394531 C 0.457031 -0.503906 0.378906 -0.570312 0.253906 -0.570312 C 0.132812 -0.570312 0.0546875 -0.511719 0.0546875 -0.414062 C 0.0546875 -0.328125 0.117188 -0.28125 0.253906 -0.25 C 0.355469 -0.226562 0.398438 -0.195312 0.398438 -0.144531 C 0.398438 -0.0898438 0.347656 -0.0585938 0.269531 -0.0585938 C 0.179688 -0.0585938 0.121094 -0.101562 0.117188 -0.171875 L 0.046875 -0.171875 C 0.046875 -0.0625 0.132812 0.0117188 0.269531 0.0117188 Z M 0.269531 0.0117188 "
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.585339, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.269531 0.0117188 C 0.390625 0.0117188 0.46875 -0.0507812 0.46875 -0.148438 C 0.46875 -0.230469 0.414062 -0.277344 0.269531 -0.3125 C 0.164062 -0.339844 0.125 -0.371094 0.125 -0.414062 C 0.125 -0.46875 0.175781 -0.503906 0.253906 -0.503906 C 0.335938 -0.503906 0.386719 -0.460938 0.390625 -0.394531 L 0.460938 -0.394531 C 0.457031 -0.503906 0.378906 -0.570312 0.253906 -0.570312 C 0.132812 -0.570312 0.0546875 -0.511719 0.0546875 -0.414062 C 0.0546875 -0.328125 0.117188 -0.28125 0.253906 -0.25 C 0.355469 -0.226562 0.398438 -0.195312 0.398438 -0.144531 C 0.398438 -0.0898438 0.347656 -0.0585938 0.269531 -0.0585938 C 0.179688 -0.0585938 0.121094 -0.101562 0.117188 -0.171875 L 0.046875 -0.171875 C 0.046875 -0.0625 0.132812 0.0117188 0.269531 0.0117188 Z M 0.269531 0.0117188 "
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.313345, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0820312 0 L 0.152344 0 L 0.152344 -0.558594 L 0.0820312 -0.558594 Z M 0.0820312 0 "
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.757349, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.328125 0.0117188 C 0.464844 0.0117188 0.574219 -0.0703125 0.609375 -0.195312 L 0.535156 -0.195312 C 0.507812 -0.113281 0.425781 -0.0585938 0.332031 -0.0585938 C 0.207031 -0.0585938 0.117188 -0.152344 0.117188 -0.28125 C 0.117188 -0.410156 0.207031 -0.5 0.332031 -0.5 C 0.425781 -0.5 0.5 -0.449219 0.53125 -0.371094 L 0.605469 -0.371094 C 0.566406 -0.492188 0.460938 -0.570312 0.328125 -0.570312 C 0.164062 -0.570312 0.046875 -0.449219 0.046875 -0.28125 C 0.046875 -0.109375 0.164062 0.0117188 0.328125 0.0117188 Z M 0.328125 0.0117188 "
  }))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.620556, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.02936, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0820312 0 L 0.152344 0 L 0.152344 -0.183594 L 0.269531 -0.183594 C 0.398438 -0.183594 0.480469 -0.257812 0.480469 -0.371094 C 0.480469 -0.488281 0.398438 -0.558594 0.269531 -0.558594 L 0.0820312 -0.558594 Z M 0.152344 -0.25 L 0.152344 -0.492188 L 0.269531 -0.492188 C 0.359375 -0.492188 0.40625 -0.453125 0.40625 -0.371094 C 0.40625 -0.292969 0.359375 -0.25 0.269531 -0.25 Z M 0.152344 -0.25 "
  }))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.750966, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0820312 0 L 0.152344 0 L 0.152344 -0.199219 L 0.273438 -0.199219 L 0.410156 0 L 0.496094 0 L 0.355469 -0.207031 C 0.4375 -0.226562 0.488281 -0.289062 0.488281 -0.378906 C 0.488281 -0.492188 0.410156 -0.558594 0.296875 -0.558594 L 0.0820312 -0.558594 Z M 0.152344 -0.269531 L 0.152344 -0.492188 L 0.289062 -0.492188 C 0.367188 -0.492188 0.414062 -0.453125 0.414062 -0.378906 C 0.414062 -0.308594 0.367188 -0.269531 0.289062 -0.269531 Z M 0.152344 -0.269531 "
  }))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.506173, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.335938 0.0117188 C 0.507812 0.0117188 0.625 -0.109375 0.625 -0.28125 C 0.625 -0.449219 0.507812 -0.570312 0.335938 -0.570312 C 0.164062 -0.570312 0.046875 -0.449219 0.046875 -0.28125 C 0.046875 -0.109375 0.164062 0.0117188 0.335938 0.0117188 Z M 0.117188 -0.28125 C 0.117188 -0.410156 0.207031 -0.5 0.335938 -0.5 C 0.464844 -0.5 0.554688 -0.410156 0.554688 -0.28125 C 0.554688 -0.148438 0.464844 -0.0585938 0.335938 -0.0585938 C 0.207031 -0.0585938 0.117188 -0.148438 0.117188 -0.28125 Z M 0.117188 -0.28125 "
  }))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.388581, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0820312 0 L 0.152344 0 L 0.152344 -0.183594 L 0.269531 -0.183594 C 0.398438 -0.183594 0.480469 -0.257812 0.480469 -0.371094 C 0.480469 -0.488281 0.398438 -0.558594 0.269531 -0.558594 L 0.0820312 -0.558594 Z M 0.152344 -0.25 L 0.152344 -0.492188 L 0.269531 -0.492188 C 0.359375 -0.492188 0.40625 -0.453125 0.40625 -0.371094 C 0.40625 -0.292969 0.359375 -0.25 0.269531 -0.25 Z M 0.152344 -0.25 "
  }))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.110187, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0820312 0 L 0.429688 0 L 0.429688 -0.0664062 L 0.152344 -0.0664062 L 0.152344 -0.253906 L 0.402344 -0.253906 L 0.402344 -0.316406 L 0.152344 -0.316406 L 0.152344 -0.496094 L 0.421875 -0.496094 L 0.421875 -0.558594 L 0.0820312 -0.558594 Z M 0.0820312 0 "
  }))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.802994, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0820312 0 L 0.152344 0 L 0.152344 -0.199219 L 0.273438 -0.199219 L 0.410156 0 L 0.496094 0 L 0.355469 -0.207031 C 0.4375 -0.226562 0.488281 -0.289062 0.488281 -0.378906 C 0.488281 -0.492188 0.410156 -0.558594 0.296875 -0.558594 L 0.0820312 -0.558594 Z M 0.152344 -0.269531 L 0.152344 -0.492188 L 0.289062 -0.492188 C 0.367188 -0.492188 0.414062 -0.453125 0.414062 -0.378906 C 0.414062 -0.308594 0.367188 -0.269531 0.289062 -0.269531 Z M 0.152344 -0.269531 "
  }))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.5582, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.21875 0 L 0.289062 0 L 0.289062 -0.492188 L 0.476562 -0.492188 L 0.476562 -0.558594 L 0.0273438 -0.558594 L 0.0273438 -0.492188 L 0.21875 -0.492188 Z M 0.21875 0 "
  }))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    fill: "#d8bca7",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.272605, 25.607621)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.222656 0 L 0.292969 0 L 0.292969 -0.203125 L 0.503906 -0.558594 L 0.425781 -0.558594 L 0.257812 -0.277344 L 0.1875 -0.402344 L 0.09375 -0.558594 L 0.0117188 -0.558594 L 0.222656 -0.203125 Z M 0.222656 0 "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.ff1aee927aa51c53ffea3f3e7f201be0.svg";
export { ForwardRef as ReactComponent };